import { render } from "./TabWallet.vue?vue&type=template&id=708d5d68&scoped=true"
import script from "./TabWallet.vue?vue&type=script&lang=js"
export * from "./TabWallet.vue?vue&type=script&lang=js"

import "./TabWallet.vue?vue&type=style&index=0&id=708d5d68&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708d5d68"]])

export default __exports__